import {$controller} from "rapid/index";
import {delay, forEach, clone} from "lodash";
import SecretIdDialogController from "../../secretid/secretid-controller";
import SecretIdDialogTemplate from "../../secretid/secretid.html";
import {ConfigurationCreateController} from "../configuration-create/configuration-create";
import ConfigurationCreateTemplate from "../configuration-create/configuration-create.html";
import {DeleteDialogController} from "../../common/delete-dialog/delete-dialog";
import DeleteDialogTemplate from "../../common/delete-dialog/delete-dialog.html";
import {DEFAULT_CONFIG} from "../../../constants/defaulf-config.constant.js";

const dependencies = ["$Company", "$Configuration", "$companies", "gettextCatalog", "$mdEditDialog"];

export default class Controller extends $controller {

    constructor($injector, $scope, $state, $timeout, $auth, $window, $ToastService, $UndoDeleteService) {
        "ngInject";
        super($injector, dependencies);
        this.$state = $state;
        this.$timeout = $timeout;
        this.$window = $window;
        this.$auth = $auth;
        this.$scope = $scope;
        this.$scope.loading = true;
        this.$scope.query = {page: 1, search: ""};
        this.$scope.filter = {};
        this.$scope.configurations = [];
        this.$scope.pageCount = 0;
        this.$scope.canAddMore = true;
        this.toastService = $ToastService;
        this.undoDelete = $UndoDeleteService;
        this.$scope.logOrder = () => {
            this.$scope.query.ordering = this.$scope.query.order.replace("_", "");
            this.query(true);
        };

        this.searchByKeyPress = (event) => {
            const keyName = event.key;
            const letters = "abcdefghijklmnopqrstuvwxyz";
            if (letters.indexOf(keyName) !== -1 && (document.activeElement.tagName === "BODY" || document.activeElement.tagName === "A")) {
                this.$scope.$apply(() => {
                    this.$scope.filter.show = true;
                    if (!this.$scope.query.search) {
                        this.$scope.query.search = keyName;
                    }
                });
                delay(() => {
                    document.getElementById("search-field").focus();
                }, 100);
            }
        };
    }

    $onInit() {
        this.$scope.filter.show = false;
        this.$scope.$watch("query.search", angular.bind(this, this.onQueryFilterChange));
        document.addEventListener("keypress", this.searchByKeyPress);
    }

    $onDestroy() {
        document.removeEventListener("keypress", this.searchByKeyPress);
    }

    query(isNew) {
        this.$scope.query.page = isNew ? 1 : this.$scope.query.page;

        var configurations = this.$Configuration.query(this.$scope.query);
        Promise.all([configurations.$promise]).then(() => {
            this.$scope.query.page = configurations._meta.page || 1;
            this.$scope.loading = false;

            isNew ? this.$scope.configurations = configurations : this.$scope.configurations.push(...configurations);
            this.$scope.pageCount = configurations._meta.page_count;
            this.$scope.canAddMore = this.$scope.query.page !== this.$scope.pageCount;

            this.$scope.$apply();
        }).catch(() => {
            this.toastService.showError("Can't load list of configurations", 5000);
        });
    }

    openDeleteDialog(ev, item) {
        this.$mdDialog.show({
            title: "Configuration Delete",
            controller: DeleteDialogController,
            template: DeleteDialogTemplate,
            targetEvent: event,
            locals: {
                callback: () => {
                    this.deleteItem(ev, item);
                },
                target: "configuration",
                item: item
            }
        });
    }

    downloadAllAssets(event, item) {
        this.$auth.$http({
            url: `/api/configuration-assets-zip/`,
            method: "PUT",
            data: {
                configuration: item.id,
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
            }
        }).then((resp) => {
            if (resp.data && resp.data.zip_url) {
                this.createZip(resp.data.zip_url);
            } else {
                this.$mdToast.show(
                    this.$mdToast.simple().position("bottom right").hideDelay(5000)
                        .textContent(`This configuration has no assets!`)
                );
            }
        }).catch((e) => {
            console.log(e);
        });
    }
    createZip(zipUrl) {

        this.created = false;
        let interval = null;
        const MAX_TRIES = 60; // *5 sec


        let tryDownload = () => {
            this.downloadZip(zipUrl).then((resp)=> {
                this.created = true;
                window.location.assign(resp.data.file);
            }).catch((e) => {
                if (e.status === 510) {
                    this.created = false;
                } else {
                    this.created = true;
                }
            });
        };
        let ping = 0;
        interval = setInterval(() => {
            if (this.created || ping >= MAX_TRIES) {
                clearInterval(interval);
                if (ping >= MAX_TRIES) {
                    this.$mdToast.show(
                        this.$mdToast.simple().position("bottom right").hideDelay(5000)
                            .textContent(`Download time turned out!`)
                    );
                }
            } else {
                ping ++;
                tryDownload();
            }
        }, 5000);
    }
    downloadZip(url) {
        return this.$auth.$http({
            url: url,
            method: "GET"
        }).then((resp) => {
            return resp;
        }).catch((e) => {
            return this.$q.reject(e);
        });
    }

    deleteItem(ev, item) {
        item.$delete().then(() => {
            this.toastService.deleteToast(`Deleted configuration "${item.name}".`, () => {
                this.undoDelete.undoDelete("configurations", item.id).then(() => {
                    this.toastService.showSimple(`Deletion undone`, 5000);
                    this.query(true);
                }).catch(() => {
                    this.toastService.showError(`Could not undone deletion`, 5000);
                });
            });
            this.query(true);
        }).catch((err) => {
            console.log(err);
            this.toastService.showError(`Could not delete configuration "${item.name}".`, 5000);
        });
    }

    addMoreItems() {
        this.$scope.query.page++;
        this.query();
    }

    onQueryFilterChange() {
        this.$scope.query.page = 1;
        const newValue = clone(this.$scope.query.search);
        this.$scope.loading = true;
        this.searhDelayTimeout = setTimeout(() => {
            const prewValue = clone(this.$scope.query.search);
            if (prewValue === newValue) {
                clearTimeout(this.searhDelayTimeout);
                this.query(true);

            }
        }, 500);
    }

    addNew(event, sourceConfig=null) {
        console.log(this.$auth.isRole("Admin"));
        let parentEl = angular.element(document.body);
        this.$mdDialog.show({
            parent: parentEl,
            title: "Create new configuration",
            controller: ConfigurationCreateController,
            template: ConfigurationCreateTemplate,
            targetEvent: event,
            locals: {
                callback: (configuration) => { this.createConfig(configuration); },
                companies: this.$scope.companies,
                userCompany: this.$companies.getCached(),
                sourceConfig: sourceConfig
            }
        });
    }

    transformDeploymentsArr(arr, title) {
        let newArr = [];
        forEach(arr, (dp) => {
            newArr.push(dp.name);
        });
        let str = newArr.length > 1 ? newArr.join(title ? "\n": ", ") : newArr.join("");
        return (str.length > 25 && !title) ? `${str.slice(0,25)} ...` : str;
    }


    createConfig(configuration) {
        let createConfig = () => {
            let newConfig = this.$Configuration.create(configuration);
            newConfig.$promise
                .then(() => this.$scope.configurations.unshift(newConfig))
                .then(() => {
                   this.openConfig(newConfig);
                });
        };
        // get default configuration if set
        configuration.json = configuration.json || DEFAULT_CONFIG;
        if (this.$auth.isRole("Admin") || this.$auth.isRole("Manager")) {
            configuration = this.changeDefaultConfigForAdmins(configuration);
        }
        configuration.json.admin.isAdvanced = !configuration.enableWizard;
        delete configuration.enableWizard;
        createConfig();

    }

    showSecretID(ev, item) {
        var parentEl = angular.element(document.body);
        this.$mdDialog.show({
            parent: parentEl,
            title: "Set/Share Configuration ID",
            controller: SecretIdDialogController,
            template: SecretIdDialogTemplate,
            targetEvent: ev,
            escapeToClose: false,
            locals: {
                selectedItem: item,
                secretKind: this.gettextCatalog.getString("Configuration")
            }
        });
    }

    editName(ev, item) {
        if (["md-icon", "button"].indexOf(ev.target.tagName.toLowerCase()) < 0)
            return; // workaround for editDialog requirement - currentTarget = table cell.

        ev.stopPropagation();

        let editDialog = {
            modelValue: item.name,
            placeholder: this.gettextCatalog.getString("Enter new name"),
            save: (input) => {
                item.name = input.$modelValue;
                item.$update().then(() => {
                    this.toastService.showSimple(`Saved new configuration name "${item.name}".`, 5000);
                }).catch(() => {
                    this.toastService.showError(`Could not save new configuration name "${item.name}".`, 5000);
                });
            },
            targetEvent: ev,
            title: this.gettextCatalog.getString("Enter new name"),
            validators: {
                "md-maxlength": 50
            }
        };

        this.$mdEditDialog.small(editDialog).then((...args) => {
            console.log("$mdEditDialog promise resolved with args: ", args);
        });
    }

    setAsCompanyDefault(ev, item) {
        let company = this.$scope.companies[item.company_info];
        let msgText = "";
        if (company.default_configuration === item.url) {
            company.default_configuration = null;
            msgText = `Configuration "${item.name}" is now unset from the default for "${company.name}"`;
        } else {
            company.default_configuration = item.url;
            msgText = `Configuration "${item.name}" is now the default for "${company.name}"`;
        }
        company.$update().then(() => {
            this.toastService.showSimple(msgText, 5000);
        }).catch(() => {
            this.toastService.showError(`Could not set default configuration for "${company.name}".`, 5000);
        });
    }

    removeFilter() {
        this.$scope.filter.show = false;
        this.$scope.query.search = "";
    }

    showFilter() {
        this.$scope.filter.show = true;
        delay(() => {
            document.getElementById("search-field").focus();
        }, 100);

    }

    changeCompany(value, item) {
        if (value && value.length) {
            item.$update().then(() => {
                this.toastService.showSimple(`Configuration updated`, 5000);
                this.query(true);
            }).catch(() => {
                this.toastService.showError(`Could not update configuration "${item.name}".`, 5000);
            });
        }
    }

    openConfig(item) {
        if (item.json.admin.isAdvanced || item.json.admin.isAdvanced === undefined) {
            this.$state.go("configurations.update", {cid: this.$filter("getObjectId")(item.url)});
        } else if (item.json.admin.isAdvanced === false) {
            this.$state.go("configurations.setup", {cid: this.$filter("getObjectId")(item.url)});
        }
    }

    onSearchBlur() {
        if (!this.$scope.query.search) {
            this.$scope.filter.show = false;
        }
    }

    changeDefaultConfigForAdmins(config) {
        config.json.admin.photoBooth.startScreenDesignSharing = false;

        config.json.admin.gifBooth.startScreenDesignSharing = false;

        config.json.admin.boomerangBooth.startScreenDesignSharing = false;

        config.json.admin.digitalStartScreenDesign = false;
        config.json.admin.printStartScreenDesign = false;
        config.json.admin.stripStartScreenDesign = false;

        return config;
    }

    isClient() {
        return this.$auth.isRole("Client") || this.$auth.isRole("Sub-User");
    }

    openInNewTab(id, isAdvanced) {
        if (isAdvanced || isAdvanced === undefined) {
            this.$window.open(this.$window.location.href + id + "/", "_black");
        } else if (isAdvanced === false) {
            this.$window.open(this.$window.location.href + "setup/" + id + "/", "_blank");
        }
    }
}



// WEBPACK FOOTER //
// ./sources/components/configurations/configuration-list/configuration-list.controller.js